/**
 * RISKS-I-OWN-MOUNT-1 — GET /home/risks-i-own.
 * Active risks the caller owns. Failure is unavailable, never a numeric 0.
 */
import { request } from '@/lib/api';

export type RisksIOwnItem = {
  id: string;
  title: string;
  projectId: string;
  projectName: string | null;
  workspaceId: string;
};

export type RisksIOwnResult =
  | { status: 'ok'; count: number; items: RisksIOwnItem[] }
  | { status: 'unavailable' };

export function parseRisksIOwn(raw: unknown): RisksIOwnResult {
  const body =
    raw && typeof raw === 'object' && 'data' in raw
      ? (raw as { data: unknown }).data
      : raw;
  if (!body || typeof body !== 'object') {
    return { status: 'unavailable' };
  }
  const record = body as { status?: unknown; count?: unknown; items?: unknown };
  if (record.status === 'unavailable') {
    return { status: 'unavailable' };
  }
  if (record.status !== 'ok' || !Array.isArray(record.items) || typeof record.count !== 'number') {
    return { status: 'unavailable' };
  }
  const items: RisksIOwnItem[] = [];
  for (const row of record.items) {
    if (!row || typeof row !== 'object') return { status: 'unavailable' };
    const item = row as Partial<RisksIOwnItem>;
    if (
      typeof item.id !== 'string' ||
      typeof item.title !== 'string' ||
      typeof item.projectId !== 'string' ||
      typeof item.workspaceId !== 'string'
    ) {
      return { status: 'unavailable' };
    }
    items.push({
      id: item.id,
      title: item.title,
      projectId: item.projectId,
      projectName: typeof item.projectName === 'string' ? item.projectName : null,
      workspaceId: item.workspaceId,
    });
  }
  if (record.count !== items.length) {
    return { status: 'unavailable' };
  }
  return { status: 'ok', count: items.length, items };
}

export async function listRisksIOwn(): Promise<RisksIOwnResult> {
  const raw = await request.get<unknown>('/home/risks-i-own');
  return parseRisksIOwn(raw);
}

